<template>
  <div>
    <!-- 审核列表 -->
    <div class="app-container" v-show="tabType === 1">
      <el-card class="box-card">
        <div class="filter-container">
          <el-form :model="query" ref="queryForm" :inline="true">
            <el-form-item label="订单编号：">
              <el-input v-model="query.orderNum" placeholder="请输入订单编号" clearable size="small" />
            </el-form-item>
            <el-form-item label="客户姓名：">
              <el-input v-model="query.customerName" placeholder="请输入客户姓名" clearable size="small" />
            </el-form-item>
            <el-form-item label="时间筛选：">
              <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期" @change="handleDateChange" />
            </el-form-item>
            <el-form-item class="fr">
              <el-button type="primary" @click="doQuery" size="mini">搜索</el-button>
              <el-button type="info" @click="resetQuery" plain size="mini">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-card>

      <el-card class="box-card mt10">
        <div class="btn-right-side mb10">
          <el-tabs v-model="activeName" @tab-click="handleTabClick">
            <el-tab-pane label="待审核" name="0" />
            <el-tab-pane label="同意申请" name="1" />
            <el-tab-pane label="驳回申请" name="-1" />
          </el-tabs>
          <div class="btn-box">
            <el-dropdown v-if="activeName=='0'" v-hasPermi="['order:outboundOrder:review']">
              <el-button type="primary" size="mini">批量操作<i class="el-icon--right el-icon-arrow-down" /></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="batchApprove">批量同意</el-dropdown-item>
                <el-dropdown-item @click.native="batchReject">批量驳回</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>

        <el-table v-loading="loading" :data="tableData" ref="table" @selection-change="handleSelectionChange" :key="activeName" fit>
          <el-table-column type="selection" width="50" v-if="activeName=='0'" />
          <el-table-column prop="orderNum" label="订单编号" min-width="180" show-overflow-tooltip>
            <template slot-scope="{row}">
              <el-link type="primary" @click="handleShow(row)">{{ row.orderNum }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="类型" min-width="80">
            <template slot-scope="{row}">{{ row.orderType == null ? '-' : (row.orderType===2?'售后退返':(row.orderType===3?'其他':'内购')) }}</template>
          </el-table-column>
          <el-table-column label="客户信息" min-width="140">
            <template slot-scope="{row}">姓名:{{ row.customerName }}<br/>手机号:{{ row.customerPhone }}</template>
          </el-table-column>
          <el-table-column label="支付方式" min-width="80">
            <template slot-scope="{row}">{{ row.orderPayType===1?'余额':(row.orderPayType===2?'零售价':(row.orderPayType===3?'学费':'赠送')) }}</template>
          </el-table-column>
          <el-table-column label="价格明细" min-width="130">
            <template slot-scope="{row}"><span>商品:{{ row.payTotalMoney }}<br />运费:{{ row.freight||0 }}<br />应付:{{ row.allPayMoney }}</span></template>
          </el-table-column>
          <el-table-column prop="totalQuantity" label="总件数" min-width="70" />
          <el-table-column label="审核人" min-width="80" v-if="activeName!='0'">
            <template slot-scope="{row}">{{ row.reviewBy || '-' }}</template>
          </el-table-column>
          <el-table-column label="审核时间" min-width="150" v-if="activeName!='0'">
            <template slot-scope="{row}">{{ formatTime(row.reviewTime) }}</template>
          </el-table-column>
          <el-table-column label="审核备注" min-width="150" show-overflow-tooltip v-if="activeName=='-1'">
            <template slot-scope="{row}">{{ row.reviewRemark || '-' }}</template>
          </el-table-column>
          <el-table-column label="创建时间" min-width="150">
            <template slot-scope="{row}">{{ formatTime(row.createdTime) }}</template>
          </el-table-column>
          <el-table-column label="操作" align="center" min-width="140" fixed="right">
            <template slot-scope="{row}">
              <el-button type="text" @click="handleShow(row)">查看详情</el-button>
              <template v-if="activeName=='0'">
                <el-button type="text" @click="handleApprove(row)" style="color:#67c23a">同意</el-button>
                <el-button type="text" @click="handleReject(row)" style="color:#f56c6c">驳回</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQuery" />
      </el-card>
    </div>

    <!-- 订单详情(审核用,带审核按钮) -->
    <outbound-order-show v-if="tabType === 2" :rowItem="rowItem" :showAuditBtns="true" @handleShow="handleBack" @refreshAudit="doQuery" />
  </div>
</template>

<script>
import { getOrderPage } from '@/api/order/outboundOrder'
import request from '@/utils/request'
import OutboundOrderShow from '@/views/order/outboundOrder/show.vue'

export default {
  name: 'OutboundAudit',
  components: { OutboundOrderShow },
  data() {
    return {
      tabType: 1, rowItem: null,
      loading: false, activeName: '0', dateTime: [], selectedRows: [],
      query: { orderNum: '', customerName: '', reviewState: 1, startTime: '', endTime: '', pageNo: 1, pageSize: 20 },
      total: 0, tableData: []
    }
  },
  created() { this.doQuery() },
  methods: {
    doQuery() {
      this.loading = true
      getOrderPage(this.query).then(res => {
        if (res.code === '0') { this.tableData = res.data.list; this.total = res.data.total }
      }).finally(() => { this.loading = false })
    },
    formatTime(v) { if (!v) return '-'; return v.replace('T',' ') },
    handleDateChange(v) { this.query.startTime = v ? v[0] : ''; this.query.endTime = v ? v[1] : '' },
    resetQuery() {
      this.query = { orderNum: '', customerName: '', reviewState: 1, startTime: '', endTime: '', pageNo: 1, pageSize: 20 }
      this.dateTime = []; this.doQuery()
    },
    handleTabClick(tab) {
      const reviewStateMap = { '0': 1, '1': 2, '-1': -1 }
      this.query.state = undefined
      this.query.reviewState = reviewStateMap[tab.name]
      this.query.pageNo = 1
      this.doQuery()
    },
    handleSelectionChange(rows) { this.selectedRows = rows },
    handleShow(row) {
      this.rowItem = { ...row }
      this.tabType = 2
    },
    handleBack() {
      this.tabType = 1
      this.rowItem = null
      this.doQuery()
    },
    handleApprove(row) {
      this.$confirm('确认同意该出库订单？同意后将推送JST。', '审核通过', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
        request({ url: '/outbound/order/review/approve/' + row.id, method: 'post' }).then(res => {
          if (res.code === '0') { this.$message.success('已同意'); this.doQuery() }
        })
      }).catch(() => {})
    },
    handleReject(row) {
      this.$prompt('请输入驳回原因', '驳回申请', { confirmButtonText: '确定', cancelButtonText: '取消', inputPattern: /\S/, inputErrorMessage: '驳回原因不能为空' }).then(({ value }) => {
        request({ url: '/outbound/order/review/reject/' + row.id, method: 'post', params: { remark: value } }).then(res => {
          if (res.code === '0') { this.$message.success('已驳回'); this.doQuery() }
        })
      }).catch(() => {})
    },
    batchApprove() {
      if (this.selectedRows.length === 0) return this.$message.warning('请选择订单')
      this.$confirm(`确认同意选中的 ${this.selectedRows.length} 个订单？`, '批量审核通过', { type: 'warning' }).then(() => {
        Promise.all(this.selectedRows.map(row =>
          request({ url: '/outbound/order/review/approve/' + row.id, method: 'post' })
        )).then(() => { this.$message.success('批量审核通过成功'); this.doQuery() })
      }).catch(() => {})
    },
    batchReject() {
      if (this.selectedRows.length === 0) return this.$message.warning('请选择订单')
      this.$prompt('请输入驳回原因（将应用于所有选中订单）', '批量驳回', { confirmButtonText: '确定', cancelButtonText: '取消', inputPattern: /\S/, inputErrorMessage: '驳回原因不能为空' }).then(({ value }) => {
        Promise.all(this.selectedRows.map(row =>
          request({ url: '/outbound/order/review/reject/' + row.id, method: 'post', params: { remark: value } })
        )).then(() => { this.$message.success('批量驳回成功'); this.doQuery() })
      }).catch(() => {})
    }
  }
}
</script>
